import { render, staticRenderFns } from "./carrierKPI.vue?vue&type=template&id=3f43b9f1&scoped=true"
import script from "./carrierKPI.vue?vue&type=script&lang=ts"
export * from "./carrierKPI.vue?vue&type=script&lang=ts"
import style0 from "./carrierKPI.vue?vue&type=style&index=0&id=3f43b9f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43b9f1",
  null
  
)

export default component.exports